import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysAdvisorRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    // Preload dashboard data for AI context
    const dashboardData = await this.reimaginedData.fetchDashboardData();
    return {
      employee: dashboardData.employee,
      careerPlan: dashboardData.careerPlan,
    };
  }
}
